export default __webpack_public_path__ + "static/tive-7c54b7dc082e1c71d52abfaed51e5aa0.png";